import React from "react";

const VariantSelectors = ({
  colores,
  colorSeleccionado,
  onColorChange,
  tallasDisponibles,
  tallaSeleccionada,
  onTallaChange,
}) => {
  return (
    <>
      {/* --- Selector de Color --- */}
      <div className="modern-color-section">
        {/* ✨ Estructura de encabezado mejorada */}
        <div className="modern-section-header">
          <h3>Color: <strong>{colorSeleccionado?.color}</strong></h3>
        </div>
        <div className="modern-color-options">
          {colores.map((color) => (
            <label
              key={color.idProductoColor}
              className={`modern-color-option ${
                colorSeleccionado?.idProductoColor === color.idProductoColor
                  ? "selected"
                  : ""
              }`}
            >
              <input
                type="radio"
                name="color"
                checked={
                  colorSeleccionado?.idProductoColor === color.idProductoColor
                }
                onChange={() => onColorChange(color)}
              />
              <div
                className="modern-color-circle"
                style={{ backgroundColor: color.colorHex || "#ccc" }}
              />
            </label>
          ))}
        </div>
      </div>

      {/* --- Selector de Talla --- */}
      <div className="modern-size-section">
        {/* ✨ Estructura de encabezado mejorada y consistente */}
        <div className="modern-section-header">
            <h3>Talla: <strong>{tallaSeleccionada?.talla}</strong></h3>
        </div>
        <div className="modern-size-options">
          {tallasDisponibles.map((talla) => (
            <label
              key={talla.idProductoTalla}
              className={`modern-size-option ${
                talla.stock === 0 ? "out-of-stock" : ""
              } ${
                tallaSeleccionada?.idProductoTalla === talla.idProductoTalla
                  ? "selected"
                  : ""
              }`}
            >
              <input
                type="radio"
                name="talla"
                disabled={talla.stock === 0}
                checked={
                  tallaSeleccionada?.idProductoTalla === talla.idProductoTalla
                }
                onChange={() => onTallaChange(talla)}
              />
              <span>{talla.talla}</span>
            </label>
          ))}
        </div>
      </div>
    </>
  );
};

export default React.memo(VariantSelectors);